export const isMocking = false && process.env.NODE_ENV === 'development'
export const mockDelay = 1000
export const mockedEvent = isMocking ? (eventName => `${eventName}___MOCK`) : (eventName => eventName)

export const RESPONSE_DATA = data => ({ ok: true, problem: null, data })
export const RESPONSE_OK = RESPONSE_DATA({})

export const RESPONSE_ERROR = (problem, data) => ({ ok: false, problem, data })

export const randomBetween = (min, max) => Math.floor(Math.random() * (max + 1 - min)) + min
export const randomBoolean = () => Math.random() > 0.5
export const randomToken = (length = 36) =>
    Math.random()
        .toString(length)
        .substr(2)

export const getMockSocket = (event, data, timeout = mockDelay) => ({
    mock: true,
    timeout,
    responseEvent: event,
    response: RESPONSE_DATA(data)
})



// WEBPACK FOOTER //
// src/api/mockupUtils.js